import {
  Autocomplete,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const StateSelect = ({
  label = "State",
  value,
  disabled = false,
  onBlur = () => {},
  onChange = () => {},
  error,
}) => {
  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common,
    Translation: state.Translation.translation?.Common || {},
  }));

  const state = Common?.State || [];

  const selectedOption = React.useMemo(() => {
    return state.find((item) => item.ID === value) || null;
  }, [state, value]);

  return (
    <FormControl fullWidth>
      <FormLabel color="secondary" required label>
        {/* {label} */}
        {Translation?.State}
      </FormLabel>
      <Autocomplete
        options={state}
        autoHighlight
        getOptionLabel={(option) => option.Value}
        clearIcon={false}
        value={selectedOption}
        disabled={disabled}
        onBlur={onBlur}
        onChange={(value, newVal) => onChange(newVal)}
        noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Typography key={key} {...optionProps}>
              {option?.Value}
            </Typography>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            error={Boolean(error)}
            name="StateID"
            placeholder={Translation?.EnterYourState}
            helperText={error}
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: "new-password",
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default React.memo(StateSelect);
